import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { FileText, ArrowRight } from 'lucide-react';

const LegalNews = ({ news }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('uk-UA', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const scrollToConsultation = () => {
    document.getElementById('consultation')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Show empty state if no news
  if (!news || news.length === 0) {
    return (
      <section id="news" className="section-container">
        <div className="content-wrapper">
          <h2 className="section-title">Актуальні новини законодавства</h2>
          <div className="news-empty-state">
            <div className="news-empty-icon">
              <FileText size={48} />
            </div>
            <p className="news-empty-text">
              Наразі розділ оновлюється. Слідкуйте за новинами або залиште запит на консультацію.
            </p>
            <Button onClick={scrollToConsultation} className="btn-primary news-empty-cta">
              Зв'язатися
              <ArrowRight size={18} />
            </Button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="news" className="section-container">
      <div className="content-wrapper">
        <h2 className="section-title">Актуальні новини законодавства</h2>
        <div className="news-grid">
          {news.map((item) => (
            <Card key={item.id} className="news-card">
              <CardHeader>
                <div className="news-date">{formatDate(item.date)}</div>
                <CardTitle className="news-card-title">{item.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="news-card-description">
                  {item.summary}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LegalNews;
